/* ============================================================
   MELOHAI SHOWCASE — JS v3.3
   État actif isolé · mobile visible · multi-instance robuste
   Juin 2026
   ============================================================ */

(function () {
  'use strict';

  if (window.__melohaiShowcaseLoaded) return;
  window.__melohaiShowcaseLoaded = true;

  var registry = new WeakSet();

  function init() {
    document.querySelectorAll('[data-melohai-sc]').forEach(function (sc) {
      if (registry.has(sc)) return;
      registry.add(sc);
      initShowcase(sc);
    });
  }

  function watch() {
    if (typeof MutationObserver === 'undefined') return;
    new MutationObserver(function (mutations) {
      var dirty = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 &&
              (n.hasAttribute('data-melohai-sc') || n.querySelector('[data-melohai-sc]'))) {
            dirty = true;
          }
        });
      });
      if (dirty) init();
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ----------------------------------------------------------
     UTILITAIRE VISIBILITÉ
     Fiable même quand l'élément est masqué par CSS (display:none
     via media query — offsetWidth/Height = 0 dans ce cas).
  ---------------------------------------------------------- */

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  /* ----------------------------------------------------------
     SHOWCASE
  ---------------------------------------------------------- */

  function initShowcase(sc) {
    var audio      = sc.querySelector('[data-sc-audio]');
    var playBtn    = sc.querySelector('[data-sc-play]');
    var progress   = sc.querySelector('[data-sc-progress]');
    var seek       = sc.querySelector('[data-sc-seek]');
    var timeCur    = sc.querySelector('[data-sc-current]');
    var timeDur    = sc.querySelector('[data-sc-duration]');
    var nowTitle   = sc.querySelector('[data-sc-now-title]');
    var nowDesc    = sc.querySelector('[data-sc-now-desc]');
    var nowKicker  = sc.querySelector('[data-sc-now-kicker]');
    var lyricsWrap = sc.querySelector('[data-sc-lyrics]');
    var trackBar   = sc.querySelector('[data-sc-track]');
    var errorMsg   = sc.querySelector('[data-sc-error-msg]');

    if (!audio || !playBtn) return;

    var selectors = sc.querySelectorAll('[data-sc-selector]');
    var isSeeking = false;

    /* Nombre total d'extraits uniques (index 0..N-1) */
    var maxIdx = 0;
    selectors.forEach(function (el) {
      var i = parseInt(el.getAttribute('data-sc-selector'), 10);
      if (i > maxIdx) maxIdx = i;
    });

    /* --- Sélection d'un extrait --- */

    function selectTrack(idx) {
      if (!audio.paused) audio.pause();
      setState(sc, 'playing', false);
      setState(sc, 'ended',   false);
      setState(sc, 'loading', false);
      setState(sc, 'error',   false);
      if (errorMsg) errorMsg.style.display = 'none';

      var active = null;
      selectors.forEach(function (el) {
        var i = parseInt(el.getAttribute('data-sc-selector'), 10);
        var isActive = (i === idx);

        /* État actif interne MELOHAI uniquement. Aucun attribut générique
           susceptible d'être restylé par Dawn. */
        el.classList.toggle('melohai-sc__selector--active', isActive);

        if (isActive && !active) active = el;
      });

      if (!active) return;

      var src    = active.getAttribute('data-sc-src')    || '';
      var title  = active.getAttribute('data-sc-title')  || '';
      var desc   = active.getAttribute('data-sc-desc')   || '';
      var label  = active.getAttribute('data-sc-label')  || '';
      var dur    = active.getAttribute('data-sc-dur')    || '--:--';
      var lyrics = active.getAttribute('data-sc-lyrics') || '';

      /* Carte désactivée si pas de source */
      selectors.forEach(function (el) {
        if (parseInt(el.getAttribute('data-sc-selector'), 10) === idx) {
          if (!src) {
            el.setAttribute('data-sc-disabled', '');
          } else {
            el.removeAttribute('data-sc-disabled');
          }
        }
      });

      if (!src) {
        setState(sc, 'error', true);
        if (errorMsg) errorMsg.style.display = 'block';
        return;
      }

      /* Changer la source */
      audio.src = src;
      audio.load();

      /* Mettre à jour la UI */
      if (nowTitle)         nowTitle.textContent  = title;
      if (nowDesc)          nowDesc.textContent   = desc;
      if (nowKicker && label) nowKicker.textContent = label;
      if (timeDur)          timeDur.textContent   = dur;
      if (timeCur)          timeCur.textContent   = '0:00';
      if (progress)         progress.style.width  = '0%';
      if (seek)             seek.value = 0;
      if (playBtn)          playBtn.setAttribute('aria-label', 'Lire l\'extrait ' + title);

      renderLyrics(lyrics, lyricsWrap);
    }

    /* --- Paroles --- */

    function renderLyrics(raw, wrap) {
      if (!wrap) return;
      wrap.innerHTML = '';
      if (!raw || !raw.trim()) return;

      raw.split('||').forEach(function (seg) {
        seg = seg.trim();
        if (!seg) return;
        var p = document.createElement('p');
        p.className = 'melohai-sc__line';
        if (seg.indexOf('|') !== -1) {
          var parts = seg.split('|');
          p.setAttribute('data-sc-time', parts[0].trim());
          p.textContent = parts[1].trim();
        } else {
          p.textContent = seg;
        }
        wrap.appendChild(p);
      });
      resetLyrics(wrap);
    }

    /* --- Sélecteurs cliquables + clavier --- */

    /* Est-ce que cet index est désactivé ? */
    function isDisabled(idx) {
      var el = sc.querySelector('[data-sc-selector="' + idx + '"]');
      return el && el.hasAttribute('data-sc-disabled');
    }

    /* Trouver le prochain index valide dans une direction */
    function findNextAvailable(from, direction) {
      var i = from + direction;
      while (i >= 0 && i <= maxIdx) {
        if (!isDisabled(i)) return i;
        i += direction;
      }
      return from;
    }

    selectors.forEach(function (el) {
      el.addEventListener('click', function () {
        if (el.hasAttribute('data-sc-disabled')) return;
        selectTrack(parseInt(el.getAttribute('data-sc-selector'), 10));
      });

      el.addEventListener('keydown', function (e) {
        if (el.hasAttribute('data-sc-disabled') && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          return;
        }
        var idx = parseInt(el.getAttribute('data-sc-selector'), 10);

        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectTrack(idx);

        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          var next = findNextAvailable(idx, 1);
          selectTrack(next);
          focusSelector(next);

        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          var prev = findNextAvailable(idx, -1);
          selectTrack(prev);
          focusSelector(prev);
        }
      });
    });

    /* Focus uniquement sur l'élément VISIBLE avec cet index */
    function focusSelector(idx) {
      var candidates = sc.querySelectorAll('[data-sc-selector="' + idx + '"]');
      for (var i = 0; i < candidates.length; i++) {
        if (isVisible(candidates[i])) {
          candidates[i].focus();
          return;
        }
      }
    }

    /* --- Play / Pause --- */

    function togglePlay() {
      pauseAll(sc);

      if (audio.paused || audio.ended) {
        if (audio.ended) {
          audio.currentTime = 0;
          setState(sc, 'ended', false);
          resetLyrics(lyricsWrap);
        }
        setState(sc, 'loading', true);
        setState(sc, 'playing', false);

        var p = audio.play();
        if (p && p.catch) {
          p.catch(function () { setState(sc, 'loading', false); });
        }
      } else {
        audio.pause();
      }
    }

    playBtn.addEventListener('click', togglePlay);

    /* --- Événements audio --- */

    audio.addEventListener('playing', function () {
      setState(sc, 'loading', false);
      setState(sc, 'ended',   false);
      setState(sc, 'playing', true);
      setState(sc, 'error',   false);
      var t = nowTitle ? nowTitle.textContent : '';
      if (playBtn) playBtn.setAttribute('aria-label', 'Mettre en pause l\'extrait ' + t);
    });

    audio.addEventListener('pause', function () {
      if (!audio.ended) {
        setState(sc, 'playing', false);
        setState(sc, 'loading', false);
        var t = nowTitle ? nowTitle.textContent : '';
        if (playBtn) playBtn.setAttribute('aria-label', 'Lire l\'extrait ' + t);
      }
    });

    audio.addEventListener('ended', function () {
      setState(sc, 'playing', false);
      setState(sc, 'loading', false);
      setState(sc, 'ended',   true);
      if (progress) progress.style.width = '100%';
    });

    audio.addEventListener('waiting', function () {
      if (!audio.paused) setState(sc, 'loading', true);
    });

    audio.addEventListener('canplay', function () {
      if (sc.hasAttribute('data-sc-loading') && !audio.paused) {
        setState(sc, 'loading', false);
      }
    });

    audio.addEventListener('error', function () {
      setState(sc, 'loading', false);
      setState(sc, 'playing', false);
      setState(sc, 'error',   true);
      if (errorMsg) errorMsg.style.display = 'block';
    });

    /* --- Durée --- */

    function setDuration() {
      var d = audio.duration;
      if (d && !isNaN(d) && d !== Infinity) {
        if (timeDur) timeDur.textContent = fmt(d);
        if (seek)    seek.max = d;
      }
    }

    audio.addEventListener('loadedmetadata', setDuration);
    audio.addEventListener('durationchange', setDuration);
    setDuration();

    /* --- Progression & paroles sync --- */

    audio.addEventListener('timeupdate', function () {
      if (timeDur && timeDur.textContent === '--:--') setDuration();
      if (isSeeking) return;

      var cur = audio.currentTime;
      var dur = audio.duration;
      if (!dur || isNaN(dur) || dur === Infinity) return;

      if (progress) progress.style.width = ((cur / dur) * 100) + '%';
      if (seek)     seek.value = cur;
      if (timeCur)  timeCur.textContent = fmt(cur);

      if (lyricsWrap && lyricsWrap.querySelector('[data-sc-time]')) {
        syncLyrics(lyricsWrap, cur);
      }
    });

    /* --- Seek --- */

    if (seek) {
      seek.setAttribute('aria-label', 'Progression de l\'extrait');

      seek.addEventListener('input', function () {
        isSeeking = true;
        var val = parseFloat(seek.value);
        var dur = audio.duration;
        if (dur && !isNaN(dur)) {
          if (progress) progress.style.width = ((val / dur) * 100) + '%';
          if (timeCur)  timeCur.textContent  = fmt(val);
        }
      });

      seek.addEventListener('change', function () {
        audio.currentTime = parseFloat(seek.value);
        isSeeking = false;
      });
    }

    if (trackBar) {
      trackBar.addEventListener('click', function (e) {
        if (e.target === seek) return;
        var rect = trackBar.getBoundingClientRect();
        var dur  = audio.duration;
        if (dur && !isNaN(dur)) {
          audio.currentTime = ((e.clientX - rect.left) / rect.width) * dur;
        }
      });
    }

    /* --- Init premier extrait avec audio disponible --- */
    var firstAvailable = -1;
    var seen = {};
    selectors.forEach(function (el) {
      var i = parseInt(el.getAttribute('data-sc-selector'), 10);
      if (seen[i]) return;
      seen[i] = true;
      var src = el.getAttribute('data-sc-src') || '';
      if (src && firstAvailable === -1) firstAvailable = i;
    });

    if (firstAvailable === -1) {
      setState(sc, 'error', true);
      if (errorMsg) errorMsg.style.display = 'block';
      if (playBtn) playBtn.disabled = true;
      return;
    }

    selectTrack(firstAvailable);
  }

  /* ----------------------------------------------------------
     PAROLES SYNCHRONISÉES
  ---------------------------------------------------------- */

  function parseTC(tc) {
    if (!tc) return -1;
    tc = tc.trim();
    if (tc.indexOf(':') !== -1) {
      var parts = tc.split(':');
      return (parseInt(parts[0], 10) || 0) * 60 + (parseInt(parts[1], 10) || 0);
    }
    var n = parseFloat(tc);
    return isNaN(n) ? -1 : n;
  }

  function syncLyrics(wrap, cur) {
    var lines = wrap.querySelectorAll('.melohai-sc__line[data-sc-time]');
    if (!lines.length) return;

    var active = -1;
    for (var i = lines.length - 1; i >= 0; i--) {
      if (parseTC(lines[i].getAttribute('data-sc-time')) <= cur) {
        active = i; break;
      }
    }

    lines.forEach(function (l, j) {
      if (j === active) {
        if (!l.classList.contains('is-active')) {
          l.classList.add('is-active');
          l.classList.remove('is-past');
          scrollLine(wrap, l);
        }
      } else if (j < active) {
        l.classList.remove('is-active');
        l.classList.add('is-past');
      } else {
        l.classList.remove('is-active', 'is-past');
      }
    });
  }

  function resetLyrics(wrap) {
    if (!wrap) return;
    wrap.querySelectorAll('.melohai-sc__line').forEach(function (l) {
      l.classList.remove('is-active', 'is-past');
    });
    wrap.scrollTop = 0;
  }

  function scrollLine(container, line) {
    var cR = container.getBoundingClientRect();
    var lR = line.getBoundingClientRect();
    container.scrollBy({
      top: (lR.top - cR.top + lR.height / 2) - cR.height / 2,
      behavior: 'smooth'
    });
  }

  /* ----------------------------------------------------------
     STOPPER TOUS LES AUTRES PLAYERS
  ---------------------------------------------------------- */

  function pauseAll(except) {
    document.querySelectorAll('[data-melohai-xp], [data-melohai-sc]').forEach(function (el) {
      if (el === except) return;
      var a = el.querySelector('[data-mx-audio], [data-sc-audio]');
      if (a && !a.paused) a.pause();
    });
  }

  /* ----------------------------------------------------------
     UTILITAIRES
  ---------------------------------------------------------- */

  function setState(el, state, on) {
    if (on) el.setAttribute('data-sc-' + state, '');
    else    el.removeAttribute('data-sc-' + state);
  }

  function fmt(sec) {
    if (!sec || isNaN(sec)) return '0:00';
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  /* ----------------------------------------------------------
     GO
  ---------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); watch(); });
  } else {
    init(); watch();
  }

})();
